import { ContentLanguageTranslation } from '../../../types/InternalAnalystComment'

export enum GameReviewField {
  GenreAndStyle = 'genreAndStyle',
  FeaturesAndProgression = 'featuresAndProgression',
  Monetization = 'monetization',
  SpecialNotes = 'specialNotes',
}

export const gameReviewFields = [
  GameReviewField.GenreAndStyle,
  GameReviewField.FeaturesAndProgression,
  GameReviewField.Monetization,
  GameReviewField.SpecialNotes,
]

type AuditFields = {
  createdAt?: number
  modifiedAt?: number
  createdBy?: string | null
  modifiedBy?: string | null
}

export type GameReviewContent = Record<GameReviewField, ContentLanguageTranslation | null>

export type InternalGameReview = AuditFields & {
  id: string
  appId: number
  analystId: string | null
  published: boolean
  content: Partial<GameReviewContent> | null
}

// Creates with `id: null`, updates otherwise.
export type GameReviewMutation = {
  id: string | null
  appId: number
  published: boolean
  analystId: string | null
  content: GameReviewContent
}

export type InternalAnalysisComment = AuditFields & {
  id: string
  gameId: string
  gameVersion: string
  analystId: string | null
  published: boolean
  content: { comment?: ContentLanguageTranslation | null } | null
}

export type AnalysisCommentMutation = {
  id: string | null
  gameId: string
  gameVersion: string
  published: boolean
  analystId: string | null
  content: { comment: ContentLanguageTranslation | null }
}
